export const ONE_TRUST_FORCE_BANNER_DEBUG_LOCAL_STORAGE_KEY = 'milanote.debug.oneTrust.forceBanner';
